<template>

    <div class="col-md-3 col-sm-6 mb-sm-4 profile-block" v-if="userProp" e2e-id="regular-escort-block"
         :class="{
            'profile-block-plus':showPlusFeatures,
            'profile-block--lock': (showLockIcon && !photoIsExplicit),
            'profile-block--simplified': isSimplified
         }">

        <a :href="regionRelativeUrl(userProp.profile_path)" @click.prevent="onProfileClick" class="profile-block-link">

            <span class="profile-block-images">

                <div class="plus-box-shadow" v-if="showPlusFeatures"></div>

                <explicit-photo-placeholder v-if="photoIsExplicit"
                                            :show-action-buttons="false"
                                            e2e-id="search-photo-first-explicit"
                                            verificationOrigin="search"
                                            class="profile-block-images--explicit-photo"
                                            :profileUserId="userProp.id">
                </explicit-photo-placeholder>
                <picture class="lozad lazyload-img" v-else e2e-id="search-photo-first"
                         :data-iesrc="getPhotoUrl(userProp,'jpg','medium')">

                    <source :srcset="getPhotoSrcSet(userProp,'webp')"
                            class="lazyload-src" type="image/webp">
                    <source :srcset="getPhotoSrcSet(userProp,'jpg')"
                            class="lazyload-src" type="image/jpeg">

                    <!-- SEO: keep src="" EMPTY. Real src here (commit 528f2648) exposed ~30 photos/page to Googlebot-Image and killed SERP SEO — see CLAUDE.md "SEO Hard Rules". -->
                    <noscript>
                        <img src="" class="lazyload-img lazyload-noscript" :style="'  background: url(' +
                             getPhotoUrl(userProp,'jpg','medium') +') no-repeat;'" alt="">
                    </noscript>

                    <div class="profile-block-images-top-vip-tag"
                         v-if="getPhotoObject(userProp) && getPhotoObject(userProp).explicit">
                        <img src="/images/viptag.png" alt="">
                    </div>
                </picture>

            </span>

        </a>

        <span class="profile-block-images-badge-container" v-if="!isSimplified && (showAvailable || userProp.isOnline)">
            <span class="profile-block-images-badge-container-right-wrapper"
                 :class="{'profile-block-images-badge-container-right-wrapper--verified': showVerified}">
                <span v-if="userProp.isOnline" class="small-banner online">
                    {{ translate.home.onlineNow }}
                </span>
                <span v-else-if="showAvailable" class="small-banner available">
                    <icon-component :icon="fa_calendar()"></icon-component>
                    {{ translate.account.availableToday }}
                </span>
            </span>
        </span>

        <span class="profile-block-details">

            <span class="user-details overflow-hidden">
                <span class="heading-1 d-flex">
                    <span class="text-ellipsis" e2e-id="search-profile-username">{{ userProp.username }}</span>
                    <span class="flex-shrink-0 flex-grow-0">{{ getUserAge(userProp, ', ') }}</span>
                    <span class="mx-2 color-red-base" v-if="userProp.score !== undefined">{{
                            ` SCORE: ${userProp.score}`
                        }}</span>
                    <icon-component v-if="showVerified" :icon="checkBadge()" width="16px" height="16px"
                                    class="flex-shrink-0 ml-2"/>
                    <icon-component v-if="userProp.private_gallery_photos_count" :icon="fa_gem()" force-current-color
                                    width="16px" height="16px" class="flex-shrink-0 ml-2"/>
                    <icon-component v-if="userProp.total_videos_count" :icon="fa_video_play()" force-current-color
                                    width="16px" height="16px" class="flex-shrink-0 ml-2"/>
                </span>
                <template v-if="!isSimplified">
                    <span class="user-details-location d-flex overflow-hidden"
                          v-if="!userProp.found_by_outcall_location">
                        <span class="text-ellipsis">{{ getUserLocationForSearch(userProp) }}</span>

                        <span class="distance">
                            <template v-if="userProp.distance >=0">
                                {{ userProp.distance + 'km' }}
                            </template>
                            <template v-else>
                                <a href="#" @click.prevent="onDistanceClick(userProp)">{{
                                    translate.home.distance
                                }}</a>
                            </template>
                        </span>
                    </span>
                    <span v-if="userProp.outcall_distance && isUkRegion"
                          class="user-details-location d-flex overflow-hidden user-details-location--outcall"
                          v-html="outCallDistanceHTML"></span>
                    <span v-else-if="userProp.outcall_distance"
                          class="user-details-location d-flex overflow-hidden">{{ outCallDistance }}</span>
                </template>
            </span>
            <div class="plus" v-if="showPlusFeatures">
                {{ translate.product.plus }} <icon-component width="1.25em" :icon="fa_star()"></icon-component>
            </div>
        </span>

    </div>

</template>

<script>

import userMixin from "@/components/mixins/userMixin";
import photoMixin from "@/components/mixins/photoMixin";
import ExplicitPhotoPlaceholderComponent from "@/components/partials/ExplicitPhotoPlaceholderComponent";
import PrivateGallerySearchIconComponent
    from "@/components/search/partials/icons/PrivateGallerySearchIconComponent.vue";
import translateMixin from "@/components/mixins/translateMixin";
import {isEscortAvailableToday} from "@/core/utils/helpers/users/escort/escortHelpers";
import escortViewMixin from "@/components/mixins/search/escortViewMixin";
import {checkBadge, fa_calendar, fa_gem, fa_star, fa_users, fa_video, fa_video_play} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";
import regionsUrlMixin from "@/components/mixins/regions/regionsUrlMixin";
import {regionRelativeUrl, isUnitedKingdomRegion} from "@/core/utils/helpers/regions/regionUrlHelper";
import {RegionalExplicitEnum} from "@/core/constants/enums/regionalExplicitEnum";

const data = () => {
    return {
        maxCityLength: 18,
    }
}

function onDistanceClick() {
    this.$emit('onDistanceClick');
}

function onProfileClick() {
    if (this.isSimplified && typeof window !== "undefined") {
        return window.open(regionRelativeUrl(this.userProp.profile_path), '_blank')
    }

    this.$emit('onUserClick', this.userProp)
}

function isUkRegion() {
    return isUnitedKingdomRegion();
}

export default {
    data,
    computed: {
        ...mapState(['translate', 'location', 'currentUser', 'userIsFromExplicitRegion']),
        isUkRegion,
        photoIsExplicit() {
            if (_.isEqual(_.get(this, 'currentUser.allowed_explicit_photo'), this.userProp.id)) {
                return false;
            }

            if (this.isAgeVerified || this.isVipPunter) {
                return false;
            }

            const regionalExplicit = _.get(this, 'userProp.photos_data.0.regionalExplicit');
            if ((regionalExplicit === RegionalExplicitEnum.YES || regionalExplicit === RegionalExplicitEnum.ERROR) && this.userIsFromExplicitRegion) {
                return true;
            }

            const photo = this.getPhotoObject(this.userProp);
            return !!_.get(photo, 'explicit');
        },
        showLockIcon() {
            if (this.isSimplified) {
                return false;
            }

            if (this.isSilverUser(this.userProp)) {
                return false;
            }

            if (isEscortAvailableToday(this.userProp)) {
                return false;
            }

            if (_.get(this, 'userProp.is_locked', false)) {
                return true;
            }

            if (!_.get(this, 'userProp.is_blurred', false)) {
                return false;
            }

            return !(this.isPunter && !this.isUserAdmin);
        },
        showPlusFeatures() {
            return !this.isSimplified && this.isSilverUser(this.userProp);
        },
        showVerified() {
            return !this.photoIsExplicit && _.get(this, 'userProp.verification_status') === 1
        },
        showAvailable() {
            return isEscortAvailableToday(this.userProp);
        },
    },
    props: ['userProp', 'isSimplified'],
    mixins: [
        userMixin,
        photoMixin,
        translateMixin,
        escortViewMixin,
        regionsUrlMixin,
    ],
    components: {
        IconComponent,
        'explicit-photo-placeholder': ExplicitPhotoPlaceholderComponent,
        'private-gallery-search-icon': PrivateGallerySearchIconComponent,
    },
    methods: {
        fa_video_play,
        fa_gem,
        fa_calendar,
        checkBadge,
        fa_users,
        fa_video,
        fa_star,
        onDistanceClick,
        onProfileClick,
    },
}
</script>
